import axiosClient from './axiosClient';

const areaApi = {
  // lay danh sach vung
  getAreaList: (params = {}) => {
    const url = '/area';
    return axiosClient.get(url, { params });
  },

  // lay chi tiet vung
  getAreaDetail: (areaId) => {
    const url = `/area/${areaId}`;
    return axiosClient.get(url);
  },
};

export default areaApi;
